export const TOOL_TECH = [
  {
    id: "clang",
    name: "C Language",
  },
  {
    id: "cpp",
    name: "C++",
  },
  {
    id: "java",
    name: "Java",
  },
  {
    id: "csharp",
    name: "C#",
  },
  {
    id: "html",
    name: "HTML",
  },
  {
    id: "css",
    name: "CSS",
  },
  {
    id: "javascript",
    name: "JavaScript",
  },
  {
    id: "php",
    name: "PHP",
  },
  {
    id: "flutter",
    name: "Flutter",
  },
  {
    id: "react",
    name: "ReactJS",
  },
  {
    id: "nodejs",
    name: "NodeJS",
  },
  {
    id: "mysql",
    name: "MySQL",
  },
  {
    id: "mongodb",
    name: "MongoDB",
  },
  {
    id: "firebase",
    name: "Firebase",
  },
  {
    id: "googlecloud",
    name: "Google Cloud",
  },
  {
    id: "git",
    name: "Git",
  },
  {
    id: "androidstudio",
    name: "Android Studio",
  },
  {
    id: "unity",
    name: "Unity Engine",
  },
  {
    id: "scenebuilder",
    name: "Scene Builder",
  },
];
